module.exports = __webpack_public_path__ + "static/img/tb6.5410830f.jpg";